<template>
  <div>
    <el-form
      ref="settlementForm"
      :model="settlement"
      class="box"
      label-width="100px"
      v-if="settlement != null"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('settlement.title')">{{
            settlement.title
          }}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('menu.suppliers')">{{
            settlement.supplierName
          }}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('settlement.direction')">{{
            $t("settlement.directionsSupplier." + settlement.settleType)
          }}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <fieldset class="mgb15">
      <legend>
        {{ $t("text.lineItem") }}
        <el-button type="default" size="mini" @click="download">
          {{ $t("action.download") }}
        </el-button>
      </legend>
      <div>
        <el-form
          :inline="true"
          @submit.native.prevent="search"
          :model="searchForm"
          size="small"
        >
          <el-form-item>
            <el-input
              size="small"
              v-model.trim="searchForm.serialNo"
              :placeholder="$t('text.serialNo')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              size="small"
              v-model.trim="searchForm.productNo"
              :placeholder="$t('product.productNo')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              native-type="submit"
            />
          </el-form-item>
        </el-form>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane name="rework">
          <span slot="label">
            {{ $t("action.rework") }}
            <span :class="reworkOty == 0 ? '' : 'red'">({{ reworkOty }})</span>
          </span>
        </el-tab-pane>
        <el-tab-pane name="selfError">
          <span slot="label">
            核对问题
            <span :class="selfErrorOty == 0 ? '' : 'red'">
              ({{ selfErrorOty }})
            </span>
          </span>
        </el-tab-pane>
        <el-tab-pane name="error">
          <span slot="label">
            对账问题
            <span :class="errorOty == 0 ? '' : 'red'">({{ errorOty }})</span>
          </span>
        </el-tab-pane>
      </el-tabs>
      <vxe-table
        :data="items"
        :loading="itemLoading"
        ref="itemsTable"
        class="recordsTable"
        size="mini"
        :scroll-y="{ enabled: false }"
        highlight-hover-row
        :row-class-name="calculateBgColor"
      >
        <vxe-table-column type="expand" width="30px">
          <template v-slot:content="{ row }">
            <span v-if="row.purchase != null">
              <el-row>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("text.createAt") }}:
                  </span>
                  {{ row.purchase.createAt }}
                </el-col>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("text.handOverAt") }}:
                  </span>
                  {{ row.purchase.handOverAt }}
                </el-col>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("purchase.giveAt") }}:
                  </span>
                  {{ row.purchase.giveAt }}
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("purchase.finishAt") }}:
                  </span>
                  {{ row.purchase.finishAt }}
                </el-col>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("purchase.supplierDeliveryAt") }}:
                  </span>
                  {{ row.purchase.supplierDeliveryAt }}
                </el-col>
                <el-col v-if="row.purchase.manualSettleAt != null" :span="8">
                  <span class="expand-field-title">
                    {{ $t("purchase.supplierDeliveryAt") }}:
                  </span>
                  {{ row.purchase.manualSettleAt }}
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("product.category") }}:
                  </span>
                  {{ row.purchase.categoryName }}
                </el-col>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("product.brand") }}:
                  </span>
                  {{ row.purchase.productBrand }}
                </el-col>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("action.downloadAttatchment") }}:
                  </span>
                  <a
                    v-if="row.purchase.attachment"
                    class="blue"
                    target="_blank"
                    :href="row.purchase.attachment"
                  >
                    {{ $t("action.downloadAttatchment") }}
                  </a>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("product.specJson") }}:
                  </span>
                  <attribute :content="row.purchase.specJson" :number="16" />
                </el-col>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("product.craftwork") }}:
                  </span>
                  <raw-html-limit-number
                    :content="row.purchase.craftwork"
                    :number="16"
                    type="richText"
                  />
                </el-col>
                <el-col :span="8">
                  <span class="expand-field-title">
                    {{ $t("text.remark") }}:
                  </span>
                  <raw-html-limit-number
                    :content="row.purchase.remark"
                    :number="16"
                    type="richText"
                  />
                </el-col>
              </el-row>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail
              :images="row.purchase.images"
              v-if="row.purchase != null"
            ></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.purchase != null">
              {{ row.purchase.serialNo }}
              <div v-if="row.purchase.workflowState != null">
                <state-label :state="row.purchase.workflowState">{{
                  $t("purchaseStates." + row.purchase.workflowState)
                }}</state-label>
                <span
                  v-if="row.purchase.manualSettleAt !== null"
                  class="green font10"
                  >{{ $t("delivery.settle") }}</span
                >
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="80"
          sortable
        >
          <template v-slot="{ row }">
            <span v-if="row.purchase != null">
              {{ row.purchase.productNo }}
              <div class="font10">
                {{ row.purchase.color }} {{ row.purchase.size }}
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="purchase.giveAt"
          :title="$t('purchase.giveAt')"
          min-width="110"
          sortable
        >
          <template v-slot="{ row }">
            <span v-if="row.purchase != null">
              {{ row.purchase.giveAt }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="purchase.handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
          sortable
        >
          <template v-slot="{ row }">
            <span v-if="row.purchase != null">
              {{ row.purchase.handOverAt }}
              <div
                v-if="
                  !['finished', 'untrod'].includes(
                    row.purchase.workflowState
                  ) && row.purchase.handOverAt != null
                "
                :class="
                  Util.dateDiff(row.purchase.handOverAt, new Date()) > 0
                    ? ''
                    : 'red'
                "
                class="font10"
              >
                {{ $t("text.handOverAtDateMinus")
                }}{{ Util.dateDiff(row.purchase.handOverAt, new Date()) }}天
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="purchase.finishAt"
          :title="$t('purchase.finishAt')"
          min-width="80"
          sortable
        >
          <template v-slot="{ row }">
            <span v-if="row.purchase != null">
              {{ row.purchase.finishAt }}
              <div
                v-if="
                  row.purchase.receiveHandDiffDay > 0 &&
                  row.purchase.workflowState == 'finished'
                "
                class="font10 orange"
              >
                {{ $t("purchase.receiveHandDiffDay")
                }}{{ row.purchase.receiveHandDiffDay }}天
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="purchase.supplierDeliveryAt"
          :title="$t('purchase.supplierDeliveryAt')"
          min-width="80"
          sortable
        >
          <template v-slot="{ row }">
            <span v-if="row.purchase != null">
              {{ row.purchase.supplierDeliveryAt }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <span v-if="row.purchase != null">
              {{ row.purchase.quantity }}{{ row.purchase.unit }}
              <div class="font10">
                {{ $t("purchase.receiveQuantity") }}:
                {{ row.purchase.receiveQuantity }}{{ row.purchase.unit }}
              </div>

              <div
                v-if="
                  row.purchase.qualityQuantity != null &&
                  row.purchase.qualityQuantity != 0
                "
                class="font10"
              >
                {{ $t("purchase.qualityQuantity") }}:{{
                  row.purchase.qualityQuantity
                }}{{ row.purchase.unit }}
              </div>
              <div
                v-if="
                  row.purchase.reworkQuantity != null &&
                  row.purchase.reworkQuantity != 0
                "
                class="font10 red"
              >
                {{ $t("purchase.reworkQuantity") }}:{{
                  row.purchase.reworkQuantity
                }}{{ row.purchase.unit }}
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('order.price')" min-width="80">
          <template v-slot="{ row }">
            <span v-if="row.purchase != null">
              {{ row.purchase.price | currency }}
              <div
                class="font10"
                v-if="
                  row.purchase.supplierQuotedPrice != null &&
                  row.purchase.supplierQuotedPrice != ''
                "
              >
                {{ $t("product.quotation") }}:
                {{ row.purchase.supplierQuotedPrice | currency }}
              </div>
              <div
                class="font10 orange"
                v-if="
                  row.purchase.changeAt != null &&
                  row.purchase.purchaseChange != null &&
                  row.purchase.purchaseChange.acceptAt == null
                "
              >
                <el-popover
                  placement="right"
                  width="300"
                  trigger="click"
                  class="mgr5"
                >
                  <div>
                    <div class="lineH24">
                      {{ $t("allocate.applyName") }}：{{
                        row.purchase.purchaseChange.applyName
                      }}
                    </div>
                    <div class="lineH24">
                      {{ $t("allocate.applyAt") }}：{{
                        row.purchase.purchaseChange.applyAt
                      }}
                    </div>
                    <div class="lineH24">
                      {{ $t("allocate.applyRemark") }}：{{
                        row.purchase.purchaseChange.applyRemark
                      }}
                    </div>

                    <div
                      class="lineH24"
                      v-if="row.purchase.purchaseChange.acceptName != null"
                    >
                      {{ $t("allocate.acceptName") }}：{{
                        row.purchase.purchaseChange.acceptName
                      }}
                    </div>
                    <div
                      class="lineH24"
                      v-if="row.purchase.purchaseChange.acceptAt !== null"
                    >
                      {{ $t("allocate.acceptAt") }}：{{
                        row.purchase.purchaseChange.acceptAt
                      }}
                    </div>
                    <div
                      class="lineH24"
                      v-if="row.purchase.purchaseChange.rejectAt !== null"
                    >
                      {{ $t("allocate.acceptAt") }}：{{
                        row.purchase.purchaseChange.rejectAt
                      }}
                    </div>
                    <div
                      class="lineH24"
                      v-if="row.purchase.purchaseChange.rejectAt !== null"
                    >
                      {{ $t("allocate.rejectReason") }}：{{
                        row.purchase.purchaseChange.rejectReason
                      }}
                    </div>
                  </div>
                  <span
                    slot="reference"
                    class="popover-reference orange font10"
                  >
                    <span
                      v-if="
                        row.purchase.purchaseChange.rejectAt == null &&
                        row.purchase.purchaseChange.acceptAt == null
                      "
                    >
                      供应商待审:{{
                        row.purchase.purchaseChange.newValue | currency
                      }}
                    </span>
                    <span v-if="row.purchase.purchaseChange.rejectAt !== null">
                      供应商拒绝:{{
                        row.purchase.purchaseChange.newValue | currency
                      }}
                    </span>
                  </span>
                </el-popover>
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('order.subtotal')" min-width="60">
          <template v-slot="{ row }">
            <span v-if="row.purchase != null">
              {{ (row.purchase.price * row.purchase.quantity) | currency }}
              <div class="font10">
                {{ $t("order.settlementRemark") }}:
                <raw-html-limit-number
                  :content="row.purchase.settlementRemark"
                  :number="6"
                />
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('settlement.settleTotal')" min-width="60">
          <template v-slot="{ row }">
            {{ row.settleTotal | currency }}
            <div class="font10">
              <raw-html-limit-number :content="row.explain" :number="8" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="selfVerifyAt"
          :title="$t('settlement.selfVerifyAt')"
          min-width="100"
        >
          <template v-slot="{ row, rowIndex }">
            {{ row.selfVerifyAt }}
            <div class="font10">
              <i
                v-if="
                  row.selfVerifyAt == null &&
                  settlement.settleType == 'Purchase'
                "
                slot="reference"
                class="el-icon-edit fl"
                @click="editSelfVerifyExplain(row, rowIndex)"
              />
              <raw-html-limit-number
                :content="row.selfVerifyExplain"
                :number="8"
              />
            </div>
            <template v-if="row.selfErrorAt != null">
              <div class="red font10">{{ row.selfErrorAt }}</div>
              <div class="red font10">
                <raw-html-limit-number
                  :content="row.selfErrorExplain"
                  :number="8"
                />
              </div>
            </template>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="verifyAt"
          :title="$t('settlement.verifyAt')"
          min-width="100"
        >
          <template v-slot="{ row, rowIndex }">
            {{ row.verifyAt }}
            <div class="font10">
              <i
                v-if="row.verifyAt == null && settlement.settleType == 'Order'"
                slot="reference"
                class="el-icon-edit fl"
                @click="editVerifyExplain(row, rowIndex)"
              />
              <raw-html-limit-number :content="row.verifyExplain" :number="8" />
            </div>
            <template v-if="row.errorAt != null">
              <div class="red font10">{{ row.errorAt }}</div>
              <div class="red font10">
                <raw-html-limit-number
                  :content="row.errorExplain"
                  :number="8"
                />
              </div>
            </template>
          </template>
        </vxe-table-column>

        <vxe-table-column field="action" :title="$t('text.action')" width="100">
          <template v-slot="{ row, rowIndex }">
            <div
              v-if="settlement.settleType == 'Purchase' && row.verifyAt == null"
            >
              <el-button
                type="text"
                size="mini"
                @click="editItem(row, rowIndex)"
                >{{ $t("text.edit") }}</el-button
              >
              <el-button
                v-if="settlement.settleType == 'Purchase'"
                type="text"
                size="mini"
                @click="deleteItem(row)"
                >{{ $t("text.remove") }}</el-button
              >
            </div>
            <div
              v-if="
                settlement.settleType == 'Purchase' && row.selfVerifyAt == null
              "
            >
              <el-button
                size="mini"
                type="text"
                @click="selfVerifyItem(row, rowIndex)"
              >
                <span v-if="row.selfErrorAt == null">
                  {{ $t("action.selfVerify") }}
                </span>
                <span v-else>{{ $t("action.clearSelfMarkError") }}</span>
              </el-button>
              <div>
                <el-button
                  v-if="row.selfErrorAt == null"
                  size="mini"
                  type="text"
                  @click="selfMarkErrorItem(row, rowIndex)"
                  >{{ $t("action.selfMarkError") }}</el-button
                >
              </div>
            </div>
            <div
              v-if="settlement.settleType == 'Order' && row.verifyAt == null"
            >
              <el-button
                size="mini"
                type="text"
                @click="verifyItem(row, rowIndex)"
              >
                <span v-if="row.errorAt == null">
                  {{ $t("action.otherVerify") }}
                </span>
                <span v-else>{{ $t("action.clearMarkError") }}</span>
              </el-button>
              <div>
                <el-button
                  v-if="row.errorAt == null"
                  size="mini"
                  type="text"
                  @click="markErrorItem(row, rowIndex)"
                  >{{ $t("action.markError") }}</el-button
                >
              </div>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </fieldset>
    <div class="right pd20">
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>

    <!-- 编辑对账说明 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('settlement.verifyExplain')])"
      :close-on-click-modal="false"
      :visible.sync="editVerifyExplainDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          size="small"
          v-model.trim="editVerifyExplainObj.verifyExplain"
          type="textarea"
          :rows="2"
        />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editVerifyExplainDoing"
          size="small"
          @click="editVerifyExplainSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editVerifyExplainDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑对账说明 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('settlement.selfVerifyExplain')])"
      :close-on-click-modal="false"
      :visible.sync="editSelfVerifyExplainDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          size="small"
          v-model.trim="editSelfVerifyExplainObj.selfVerifyExplain"
          type="textarea"
          :rows="2"
        />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editSelfVerifyExplainDoing"
          size="small"
          @click="editSelfVerifyExplainSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editSelfVerifyExplainDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑Item -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :visible.sync="editItemDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="editItemForm" :model="editItemObj" label-width="80px">
        <el-form-item
          :prop="'settleTotal'"
          :label="$t('settlement.settleTotal')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('settlement.settleTotal')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editItemObj.settleTotal" />
        </el-form-item>

        <el-form-item :prop="'explain'" :label="$t('settlement.explain')">
          <el-input
            size="small"
            v-model.trim="editItemObj.explain"
            type="textarea"
            :rows="2"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editItemDoing"
          size="small"
          @click="editItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- mark-error -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.markError')"
      :visible.sync="markErrorItemDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="markErrorItemForm"
        :model="markErrorItemObj"
        label-width="0px"
      >
        <el-form-item :prop="'errorExplain'">
          <el-input
            size="small"
            :placeholder="$t('settlement.errorExplain')"
            v-model.trim="markErrorItemObj.errorExplain"
            type="textarea"
            :rows="2"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="markErrorItemDoing"
          size="small"
          @click="markErrorItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="markErrorItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- self-mark-error -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.selfMarkError')"
      :visible.sync="selfMarkErrorItemDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="selfMarkErrorItemForm"
        :model="selfMarkErrorItemObj"
        label-width="0px"
      >
        <el-form-item :prop="'selfErrorExplain'">
          <el-input
            size="small"
            :placeholder="$t('settlement.errorExplain')"
            v-model.trim="selfMarkErrorItemObj.selfErrorExplain"
            type="textarea"
            :rows="2"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="selfMarkErrorItemDoing"
          size="small"
          @click="selfMarkErrorItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="selfMarkErrorItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Util from "@/utils";
import { page } from "@/utils/mixins.js";
import Currency from "@/components/Currency";
import Narrow from "@/components/Narrow";
import Settlement from "@/api/settlement.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    Currency,
    Narrow,
  },
  data() {
    return {
      Util: Util,
      settlement: null,
      items: [],
      itemsAll: [],
      reworkOty: 0,
      selfErrorOty: 0,
      errorOty: 0,
      itemLoading: false,
      //编辑对账说明
      editVerifyExplainDF: false,
      editVerifyExplainObj: {
        verifyExplain: null,
      },
      editVerifyExplainDoing: false,
      //
      editSelfVerifyExplainDF: false,
      editSelfVerifyExplainObj: {
        selfVerifyExplain: null,
      },
      editSelfVerifyExplainDoing: false,
      // 编辑Item
      editItemDF: false,
      editItemObj: {
        settleTotal: null,
        explain: null,
        settlementId: null,
      },
      row: null,
      rowIndex: null,
      editItemDoing: false,
      //标记
      markErrorItemDF: false,
      markErrorItemObj: {
        errorExplain: null,
      },
      markErrorItemDoing: false,
      //标记
      selfMarkErrorItemDF: false,
      selfMarkErrorItemObj: {
        selfErrorExplain: null,
      },
      selfMarkErrorItemDoing: false,
      //
      activeName: "all",
      //
      searchForm: {
        serialNo: null,
        productNo: null,
      },
      //
    };
  },
  watch: {
    id() {
      this.getSettlement();
    },
  },
  created() {
    const self = this;
    Settlement.findById(self.id).then(function (res) {
      if (res.status === 200) {
        self.settlement = res.data;
        self.getItems();
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    calculateBgColor({ row, rowIndex }) {
      if (row.purchase) {
        return row.purchase.price * row.purchase.quantity != row.settleTotal
          ? "warning-bg"
          : "";
      }
      return "";
    },
    search() {
      const self = this;
      self.handleClick();
      if (self.searchForm.serialNo != null && self.searchForm.serialNo != "") {
        self.items = self.items.filter(
          (i) =>
            i.purchase &&
            i.purchase.serialNo
              .toUpperCase()
              .indexOf(self.searchForm.serialNo.toUpperCase()) != -1
        );
      }
      if (
        self.searchForm.productNo != null &&
        self.searchForm.productNo != ""
      ) {
        self.items = self.items.filter(
          (i) =>
            i.purchase &&
            i.purchase.productNo &&
            i.purchase.productNo
              .toUpperCase()
              .indexOf(self.searchForm.productNo.toUpperCase()) != -1
        );
      }
    },

    handleClick(tab, event) {
      if (this.activeName == "all") {
        this.items = this.itemsAll;
      }
      if (this.activeName == "rework") {
        this.items = this.itemsAll.filter(
          (i) =>
            i.purchase &&
            i.purchase.reworkQuantity != null &&
            i.purchase.reworkQuantity != 0
        );
      }
      if (this.activeName == "selfError") {
        this.items = this.itemsAll.filter((i) => i.selfErrorAt != null);
      }
      if (this.activeName == "error") {
        this.items = this.itemsAll.filter((i) => i.errorAt != null);
      }

      this.reworkOty = this.itemsAll.filter(
        (i) =>
          i.purchase &&
          i.purchase.reworkQuantity != null &&
          i.purchase.reworkQuantity != 0
      ).length;

      this.selfErrorOty = this.itemsAll.filter(
        (i) => i.selfErrorAt != null
      ).length;
      this.errorOty = this.itemsAll.filter((i) => i.errorAt != null).length;
    },
    download() {
      const self = this;
      Settlement.exportExcelItem({
        settlementId: self.id,
        type: "Purchase",
      }).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 核对账单明细
    verifyItem(row, rowIndex) {
      const self = this;
      Settlement.verifyItem(self.settlement.id, row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.verifySuccess"),
            type: "success",
          });
          self.items[rowIndex].verifyAt = Util.formatDate(new Date());
          // self.getItems();
        } else {
          self.sysError();
        }
      });
    },
    markErrorItem(row, rowIndex) {
      const self = this;
      self.row = row;
      self.rowIndex = rowIndex;
      self.markErrorItemObj.errorExplain = row.errorExplain;
      self.markErrorItemDoing = false;
      self.markErrorItemDF = true;
    },
    markErrorItemSubmit() {
      const self = this;
      Settlement.markError(
        self.settlement.id,
        self.row.id,
        self.markErrorItemObj
      ).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.selfMarkErrorSuccess"),
            type: "success",
          });
          self.items[self.rowIndex].errorAt = Util.formatDate(new Date());
          self.items[self.rowIndex].errorExplain =
            self.markErrorItemObj.errorExplain;
          self.markErrorItemDF = false;
          // self.getItems();
        } else {
          self.sysError();
        }
      });
    },
    // 核对账单明细
    selfVerifyItem(row, rowIndex) {
      const self = this;
      Settlement.selfVerifyItem(self.settlement.id, row.id).then(function (
        res
      ) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.selfVerifySuccess"),
            type: "success",
          });
          self.items[rowIndex].selfVerifyAt = Util.formatDate(new Date());
          // self.getItems();
        } else {
          self.sysError();
        }
      });
    },
    // 核对问题账单明细
    selfMarkErrorItem(row, rowIndex) {
      const self = this;
      self.row = row;
      self.rowIndex = rowIndex;
      self.selfMarkErrorItemObj.selfErrorExplain = row.selfErrorExplain;
      self.selfMarkErrorItemDoing = false;
      self.selfMarkErrorItemDF = true;
    },
    selfMarkErrorItemSubmit() {
      const self = this;
      Settlement.selfMarkError(
        self.settlement.id,
        self.row.id,
        self.selfMarkErrorItemObj
      ).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.selfMarkErrorSuccess"),
            type: "success",
          });
          self.items[self.rowIndex].selfErrorAt = Util.formatDate(new Date());
          self.items[self.rowIndex].selfErrorExplain =
            self.selfMarkErrorItemObj.selfErrorExplain;
          self.selfMarkErrorItemDF = false;
          // self.getItems();
        } else {
          self.sysError();
        }
      });
    },

    // 移除
    deleteItem(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmRemove"))) {
        Settlement.deleteItem(self.settlement.id, row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getItems();
            self.getSettlement();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑账单明细
    editItem(row, rowIndex) {
      const self = this;
      self.row = row;
      self.rowIndex = rowIndex;
      self.editItemObj.settleTotal = row.settleTotal;
      self.editItemObj.explain = row.explain;
      self.editItemObj.settlementId = this.settlement.id;
      self.editItemDoing = false;
      self.editItemDF = true;
    },

    editItemSubmit() {
      const self = this;
      this.$refs.editItemForm.validate((valid) => {
        if (valid) {
          self.editItemDoing = true;
          Settlement.updateItem(
            self.settlement.id,
            self.row.id,
            self.editItemObj
          ).then(function (res) {
            self.editItemDoing = false;
            self.editItemDF = false;
            self.$message({
              message: self.$t("prompt.editSuccess"),
              type: "success",
            });
            self.items[self.rowIndex].settleTotal =
              self.editItemObj.settleTotal;
            self.items[self.rowIndex].explain = self.editItemObj.explain;
            // self.getItems();
            // self.getSettlement();
          });
        } else {
          return false;
        }
      });
    },
    // 编辑对账说明
    editVerifyExplain(row, rowIndex) {
      this.row = row;
      this.rowIndex = rowIndex;
      this.editVerifyExplainObj.verifyExplain = row.verifyExplain;
      this.editVerifyExplainDoing = false;
      this.editVerifyExplainDF = true;
    },
    editVerifyExplainSubmit() {
      const self = this;
      self.editVerifyExplainDoing = true;
      Settlement.updateVerifyExplain(
        self.settlement.id,
        self.row.id,
        self.editVerifyExplainObj
      ).then(function (res) {
        self.editVerifyExplainDoing = false;
        self.editVerifyExplainDF = false;
        if (res.status === 200) {
          self.items[self.rowIndex].verifyExplain =
            self.editVerifyExplainObj.verifyExplain;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    // 编辑对账说明
    editSelfVerifyExplain(row, rowIndex) {
      this.row = row;
      this.rowIndex = rowIndex;
      this.editSelfVerifyExplainObj.verifyExplain = row.selfVerifyExplain;
      this.editSelfVerifyExplainDoing = false;
      this.editSelfVerifyExplainDF = true;
    },
    editSelfVerifyExplainSubmit() {
      const self = this;
      self.editSelfVerifyExplainDoing = true;
      Settlement.updateSelfVerifyExplain(
        self.settlement.id,
        self.row.id,
        self.editSelfVerifyExplainObj
      ).then(function (res) {
        self.editSelfVerifyExplainDoing = false;
        self.editSelfVerifyExplainDF = false;
        if (res.status === 200) {
          self.items[self.rowIndex].selfVerifyExplain =
            self.editSelfVerifyExplainObj.selfVerifyExplain;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    //======
    getSettlement() {
      const self = this;
      Settlement.findById(self.id).then(function (res) {
        if (res.status === 200) {
          self.settlement = res.data;
        } else {
          self.sysError();
        }
        self.getItems();
      });
    },
    getItems() {
      const self = this;
      self.itemLoading = true;
      Settlement.items(self.id, { type: "Purchase" }).then(function (res) {
        self.itemLoading = false;
        if (res.status === 200) {
          self.itemsAll = res.data;
          self.items = res.data;
          self.handleClick();
        } else {
          self.sysError();
        }
      });
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>
